import 'apps/hiring/styles/components/evaluate-target-list.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import onWindowResize from 'library/hoc/on-window-resize';
import { SelectModal } from 'library/components/form-elements/select';
import AddTarget from 'apps/hiring/components/add-target';
import HiringQuery from 'apps/hiring/util/query';
import { jsonToInputParams } from 'library/util/graph';
import Confirm from 'library/helpers/confirm';

class HiringEllipse extends React.Component {
  static defaultProps = {
    onTargetReorder: ()=>{}
  }

  static propTypes = {
    onTargetSelect:PropTypes.func.isRequired,
    targets: PropTypes.array.isRequired
  }

  constructor (...params) {
    super(...params);
    this.ref = React.createRef();
  }

  state = {
    open: false
  }

  mapTargets = ({ id, name }) => (
    <option key={id} value={id}>{name}</option>
  )

  handleClick = (value) => {
    this.props.onTargetSelect(value);
    this.setState({
      open: false
    });
  }

  openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      open: true
    });
  }

  closeModal = () => {
    this.setState({
      open: false
    });
  }

  render() {
    const {
      open
    } = this.state;

    return (
      <div ref={this.ref} onClick={this.openModal} className="hiring-evaluate-target-ellipse">
        <span>...</span>
        {
          open
            ? (
              <SelectModal
                close={this.closeModal}
                handleClick={this.handleClick}
                parentRef={this.ref}
                value={''}
              >
                {
                  resolve(this.props, 'targets', []).map(this.mapTargets)
                }
              </SelectModal>
            )
            : null
        }
      </div>
    );
  }
}

class EvaluateTargetList extends React.Component {
  static defaultProps = {
    onTargetSelect: ()=>{},
    opening: false
  }

  static propTypes = {
    windowWidth: PropTypes.number,
    openingId: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    reload_graph: PropTypes.func,
    selectedTarget: PropTypes.object,
    setSelectedTarget: PropTypes.func,
    targets: PropTypes.array.isRequired,
    handleAddTargets: PropTypes.func,
    disabled: PropTypes.bool,
    opening: PropTypes.bool
  }

  state = {
    active: null,
    removing: false,
    containerWidth: 0
  }

  constructor (...params) {
    super(...params);
    this.ref = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.setContainerWidth);
    this.setContainerWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setContainerWidth);
  }

  setContainerWidth = () => {
    this.setState({ containerWidth: window.innerWidth });
  }


  get visibleTabs() {
    let count = Math.floor((this.state.containerWidth - 175) / (250 + 16));
    return count;
  }

  remove = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      removing: true
    });

    if (await Confirm()) {
      const params = {
        id: id,
        connectable_type: 'node',
        connectable_id: Number(this.props.openingId)
      };
      try {
        const { data } = await HiringQuery(`
          mutation {
            disconnect_target (${jsonToInputParams(params)}) {
              success,
              errors
            }
          }
        `);

        if (resolve(data, 'disconnect_target/success', false)) {
          await this.props.reload_graph(true, true);
        }

        if (resolve(this.props, 'selectedTarget/id', null) === id) {
          this.props.setSelectedTarget(resolve(this.props, 'targets/0/id', null));
        }
      } catch (e) {
        console.error(e);
      }
    }

    this.setState({
      removing: false
    });
  }

  mapTargets = ({ id, name, match=0 }) => (
    <div key={id} onClick={()=>!this.state.removing&&this.onTargetSelect(id)} className={['hiring-evaluate-target-target',this.props.selectedTarget.id===id?'active':null,this.state.removing?'disabled':null].filter(c=>c).join(' ')}>
      <span className={['hiring-evaluate-target-name' , this.props.opening ? 'opening' : false].filter(c=>c).join(' ')}>{ name }</span>
      {
        match
          ? (
            <span className="hiring-evaluate-target-match">{ match }</span>
          )
          : null
      }
      {
        !resolve(this.props, 'disabled', false)
          ? (
            <span onClick={(e)=>this.remove(e,id)} className={['hiring-evaluate-target-remove' , this.props.opening ? 'opening' : false].filter(c=>c).join(' ')}>
              ×
            </span>
          )
          : null
      }
    </div>
  )

  mapTargetOptions = ({ id, name }) => (
    <option key={id} value={id}>{name}</option>
  )

  onTargetSelect = (value) => {
    this.props.setSelectedTarget(value);
  }

  render() {
    const {
      disabled,
      targets,
      handleAddTargets,
      opening
    } = this.props;

    const visibleCount = this.visibleTabs;


    return (
      <div ref={this.ref} className={['hiring-evaluate-target-list', opening ? 'opening' : false].filter(c=>c).join(' ')}>
        {
          targets.slice(0, this.visibleTabs).map(this.mapTargets)
        }
        {
          visibleCount < targets.length
            ? <HiringEllipse onTargetSelect={this.onTargetSelect} targets={targets.slice(this.visibleTabs)} />
            : null
        }
        <AddTarget
          disabled={disabled}
          activeTargets={targets}
          type="button"
          className="hiring-evaluate-target-list-add"
          onTargets={handleAddTargets}
        >
          <span>+</span>
        </AddTarget>
      </div>
    );
  }
}

export default onWindowResize(EvaluateTargetList);
